import React, { RefObject } from 'react';
import { useScrollReveal } from '../../../hooks';
import { SectionHeader } from '../../../sections/ThesisSection/layouts';
import { AgentRun } from '../figures/AgentRun';
import { Band, reveal } from './Band';

export function FitsSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });
  return (
    <Band id="where-it-fits" tone="secondary">
      <div ref={ref as RefObject<HTMLDivElement>}>
        <SectionHeader
          label="Where it fits"
          title="Most of an agent is multiple choice."
          description="An agent spends most of its steps choosing between options it already has, and only a few generating text. The support agent below is one example: five of its six steps are choices, and each one can be a OneHot call."
          isVisible={isVisible}
          labelColor="ink"
        />
        <div className={`oh-fits-run ${reveal(isVisible)}`} style={{ animationDelay: '0.25s' }}>
          <AgentRun />
        </div>
      </div>
    </Band>
  );
}

export default FitsSection;
